import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { BASE_ROLE_VARIANTS, getCombinedRoleLabel } from '../../../utils/constants/packagingRoles';

// Farby zodpovedajú bootstrap variantom použitým pre badge s postavením v zozname/detaile jednotky
// (utils/constants/packagingRoles.js: BASE_ROLE_VARIANTS) - success/primary/warning/info/secondary.
// Farba sa odvodzuje len z baseRole - producerRole (čl. 3/15) je nezávislé pole, viď combinovaný
// popisok v legende (getCombinedRoleLabel), farebne sa už ďalej neodlišuje.
const VARIANT_COLORS = {
    success: '#198754',
    primary: '#0d6efd',
    warning: '#fd7e14',
    info: '#0dcaf0',
    secondary: '#6c757d',
};

const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload?.length) return null;
    const { name, value } = payload[0].payload;
    return (
        <div style={{
            background: '#fff',
            border: '1px solid #e2e8f0',
            borderRadius: 10,
            padding: '10px 16px',
            boxShadow: '0 4px 16px rgba(11,17,87,0.10)',
            color: '#0B1157',
            fontSize: 13,
        }}>
            <p style={{ margin: 0, fontWeight: 700 }}>{name}</p>
            <p style={{ margin: 0 }}>{value} {value === 1 ? 'jednotka' : value < 5 ? 'jednotky' : 'jednotiek'}</p>
        </div>
    );
};

const CustomLegend = ({ payload }) => (
    <div style={{ fontSize: 12, color: '#718094', marginTop: 8 }}>
        {payload.map((entry, i) => (
            <div key={i} className="d-flex align-items-center gap-2 mb-1">
                <span style={{
                    display: 'inline-block', width: 10, height: 10,
                    borderRadius: '50%', background: entry.color, flexShrink: 0,
                }} />
                <span style={{ color: '#0B1157' }}>{entry.payload.name}</span>
                <span style={{ marginLeft: 'auto', fontWeight: 600 }}>{entry.payload.value}</span>
            </div>
        ))}
    </div>
);

const RoleDistributionChart = ({ units }) => {
    // Zoskupuje podľa kombinácie baseRole + producerRole (napr. "Distribútor + Výrobca" je
    // samostatná kategória, odlišná od samotného "Distribútor") - obe polia sú nezávislé.
    const counts = {};
    units.forEach((u) => {
        if (!u.baseRole) return;
        const producerKey = u.producerRole === 'PRODUCER' ? 'PRODUCER' : 'NOT_APPLICABLE';
        const key = `${u.baseRole}::${producerKey}`;
        counts[key] = counts[key] ?? { baseRole: u.baseRole, producerRole: producerKey, value: 0 };
        counts[key].value += 1;
    });

    const data = Object.entries(counts).map(([key, entry]) => ({
        key,
        baseRole: entry.baseRole,
        name: getCombinedRoleLabel(entry.baseRole, entry.producerRole),
        value: entry.value,
    }));

    const isEmpty = data.length === 0;

    return (
        <div style={{
            background: '#fff',
            borderRadius: 16,
            padding: '24px 24px 16px',
            boxShadow: '0 2px 12px rgba(11,17,87,0.07)',
            height: '100%',
        }}>
            <div className="mb-4">
                <h6 style={{ color: '#0B1157', fontWeight: 700, margin: 0, fontSize: 16 }}>
                    Rozdelenie podľa postavenia
                </h6>
                <p style={{ color: '#718094', fontSize: 13, margin: '2px 0 0' }}>
                    Počet obalových jednotiek podľa role zhotoviteľ / dovozca / distribútor
                </p>
            </div>

            {isEmpty ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: 260, color: '#718094', fontSize: 14 }}>
                    Zatiaľ nie sú žiadne dáta.
                </div>
            ) : (
                <>
                    <ResponsiveContainer width="100%" height={240}>
                        <PieChart>
                            <Pie
                                data={data}
                                cx="50%"
                                cy="50%"
                                innerRadius={60}
                                outerRadius={95}
                                paddingAngle={2}
                                dataKey="value"
                            >
                                {data.map((entry, i) => (
                                    <Cell key={i} fill={VARIANT_COLORS[BASE_ROLE_VARIANTS[entry.baseRole]] ?? VARIANT_COLORS.secondary} />
                                ))}
                            </Pie>
                            <Tooltip content={<CustomTooltip />} />
                        </PieChart>
                    </ResponsiveContainer>
                    <CustomLegend payload={data.map((entry) => ({
                        color: VARIANT_COLORS[BASE_ROLE_VARIANTS[entry.baseRole]] ?? VARIANT_COLORS.secondary,
                        payload: entry,
                    }))} />
                </>
            )}
        </div>
    );
};

export default RoleDistributionChart;
